import React, { useCallback, useEffect } from "react";
import { FiCheck } from "react-icons/fi";
import { usePmsTheme } from "../../Components/PmsThemeContext";
import { useOnboardingFlow } from "../OnboardingFlowContext";
import { getOnboardingMessages } from "../onboardingI18n";

export default function LanguageSelectionStep() {
  const { languageId, languages, setLanguageId } = usePmsTheme();
  const { clearStepCommandState, markStepComplete, setStepCommandState, steps } = useOnboardingFlow();
  const copy = getOnboardingMessages(languageId);
  const stepNumber = Math.max(
    steps.findIndex((step) => step.id === "language") + 1,
    1
  );

  const handleSave = useCallback(async () => {
    markStepComplete("language");
  }, [markStepComplete]);

  useEffect(() => {
    markStepComplete("language");
  }, [markStepComplete]);

  useEffect(() => {
    setStepCommandState("language", {
      onSave: handleSave,
      canSave: true,
      canProceed: true,
      isDirty: false,
      isSaving: false,
    });

    return () => {
      clearStepCommandState("language");
    };
  }, [clearStepCommandState, handleSave, setStepCommandState]);

  return (
    <section className="onboarding-formCard onboarding-formCard--centered">
      <div className="onboarding-stepIntro">
        <div className="onboarding-eyebrow">{copy.languageStep.eyebrow}</div>
        <div className="onboarding-stepCount">{copy.progress.stepCounter(stepNumber, steps.length)}</div>
      </div>

      <h3 className="onboarding-sectionTitle">{copy.languageStep.title}</h3>
      <p className="onboarding-sectionText">{copy.languageStep.copy}</p>

      <div className="onboarding-languageGrid">
        {languages.map((option) => {
          const isActive = option.id === languageId;

          return (
            <button
              key={option.id}
              type="button"
              className={`onboarding-languageCard ${isActive ? "onboarding-languageCard--active" : ""}`}
              onClick={() => setLanguageId(option.id)}
            >
              <div className="onboarding-languageCardHead">
                <div>
                  <div className="onboarding-languageCardTitle">{option.nativeLabel || option.label}</div>
                  <div className="onboarding-languageCardMeta">{option.label}</div>
                </div>
                {isActive ? (
                  <span className="onboarding-languageCardBadge">
                    <FiCheck size={14} />
                    {copy.languageStep.selectedTag}
                  </span>
                ) : null}
              </div>
              <div className="onboarding-languageCardLocale">{option.locale}</div>
            </button>
          );
        })}
      </div>

      <p className="onboarding-note">{copy.languageStep.helper}</p>
    </section>
  );
}
